import { useEffect, useState } from 'react';
import req from 'utils/req';
import stringToKebabCase from 'utils/textHelpers/stringToKebabCase';

const FALLBACK_DESTINATION_IMAGE = 'e81aed073b6325f5de7d7bf9b363e390';

function useDestinations() {
  const [destinations, setDestinations] = useState([]);

  useEffect(() => {
    async function fetchDestinations() {
      const response = await req(
        `${URL_API_HOST}/api/v3/location-areas/top?include=location_area&desired_num_results=10`,
      )
        .get()
        .catch((e) => console.error(e));

      const { data, relations } = response;

      const formattedDestinations = relations.map((relation: any) => {
        const { experience_count } = data.find(
          (d: any) => d.id === relation.locationAreaId,
        );
        return {
          id: relation.locationAreaId,
          cloudinaryId: relation.image ?? FALLBACK_DESTINATION_IMAGE,
          country: {
            name: relation.location.country,
            slug: stringToKebabCase(relation.location.country),
          },
          city: {
            name: relation.location.area,
            slug: stringToKebabCase(relation.location.area),
          },
          nrOfExperiences: experience_count,
        };
      });

      setDestinations(formattedDestinations);
    }

    fetchDestinations();
  }, []);

  return destinations;
}

export default useDestinations;
